@if (loading) {
  <mat-progress-bar color="accent" mode="indeterminate" />
}

<div class="forms-wrapper">
  <div class="forms-toolbar">
    <div class="toolbar-copy">
      <div class="text-type-8">Forms</div>
      <div class="text-type-14">
        Forms inspectors fill in on a daily report. Add a form from another project to use it here.
      </div>
    </div>

  </div>

  <div class="forms-body">
    <div class="forms-nav">
      <mat-form-field class="nav-search" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          type="text"
          autocomplete="off"
          placeholder="Search this project and others"
          [(ngModel)]="search"
          />
        @if (search) {
          <button mat-icon-button matSuffix aria-label="Clear search" (click)="search = ''">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>

      <div class="nav-group">
        <div class="nav-group-header">
          <span>In this project</span>
          <span class="nav-count">{{ search ? visibleProjectForms.length : projectForms.length }}</span>
        </div>

        @for (item of visibleProjectForms; track item.id) {
          <div
            class="form-row"
            [class.is-selected]="item.selected"
            (click)="changeSelection(item)"
            (keydown.enter)="changeSelection(item)"
            tabindex="0"
            role="button"
            >
            <div class="row-body">
              <div class="row-name">{{ item.name }}</div>
              <div class="row-sub">
                @if (item.display_format) {
                  <span class="row-badge">{{ formatLabel(item) }}</span>
                }
                <span class="row-meta">{{ item.updated_at | date: 'MMM d, yyyy' }}</span>
              </div>
            </div>
          </div>
        } @empty {
          @if (initialized) {
            <div class="nav-empty">
              @if (search) {
                No forms here match "{{ search }}".
              } @else {
                No forms yet — add one from the list below.
              }
            </div>
          }
        }
      </div>

      <div class="nav-group">
        <div class="nav-group-header">
          <span>From other projects</span>
          <span class="nav-count">{{ search ? visibleAvailableForms.length : availableForms.length }}</span>
        </div>
        <div class="nav-group-hint">Adding one copies it into this project.</div>

        @for (item of visibleAvailableForms; track item.id) {
          <div
            class="form-row"
            [class.is-selected]="item.selected"
            (click)="changeSelection(item)"
            (keydown.enter)="changeSelection(item)"
            tabindex="0"
            role="button"
            >
            <div class="row-body">
              <div class="row-name">{{ item.name }}</div>
              <div class="row-sub">
                @if (item.display_format) {
                  <span class="row-badge">{{ formatLabel(item) }}</span>
                }
                <span class="row-meta">{{ item.project?.name }}</span>
              </div>
            </div>

            @if ('create' | able: newForm) {
              <button
                mat-icon-button
                class="row-action"
                [disabled]="!!adding"
                (click)="add(item, $event)"
                [matTooltip]="'Add to this project'"
                aria-label="Add to this project"
                >
                <mat-icon>{{ adding === item.id ? 'hourglass_empty' : 'add' }}</mat-icon>
              </button>
            }
          </div>
        } @empty {
          @if (initialized) {
            <div class="nav-empty">
              @if (search) {
                No forms here match "{{ search }}".
              } @else {
                Every form in this organization is already in this project.
              }
            </div>
          }
        }
      </div>
    </div>

    <!-- The list already names each form and where it comes from, so the second
         column is the preview itself and nothing else. -->
    <div class="form-device">
      @if (form) {
        <app-form-preview [form]="form" />
      } @else if (initialized) {
        <div class="device-empty">Select a form to preview it.</div>
      }
    </div>

    <!-- Third column, reserved: keeps the list and the phone at the left of the
         page instead of letting the preview drift into the middle. -->
    <div class="forms-aside"></div>
  </div>
</div>
